
import { Component, Vue } from 'vue-property-decorator'
import jsonp from "../../../assets/js/http";

@Component
export default class reportModal extends Vue {
    get roomData() {
        //房间数据
        return this.$store.getters["getRoomDetail/getRoomDetail"];
    }
    reportData: any = []
    radio: number = 0
    mounted() {
        this.init()
    }
    init() {
        let url = "https://pub" + this.domain + "/live/api/report/list"
        jsonp(url, {
            jsonp: "callback"
        }).then((data: any) => {
            this.reportData = data;
        });
    }
    report() {//举报
        if (this.radio <= 0) {
            return false
        }
        let url = "https://pub" + this.domain + "/live/api/report";
        this.fetch(
            {
                url: url,
                data: {
                    room_id: this.$route.params.id,
                    scene_id: this.roomData.scene_id,
                    type_id: '5'
                },
                method: 'POST'
            }).then((data: any) => {
                this.$toast("举报已受理");
                setTimeout(() => {
                    this.close();
                }, 2000);
            }, (data: any) => {
                this.$toast(data.msg);
            })
    }
    close() {
        this.$emit('isReport', false)
    }
    stop(e: any) {
        e.stopPropagation();
    }


}
